module.exports = __webpack_public_path__ + "img/average-wind-speed.bdc77bb2.svg";